import { ToastMessage } from '../hooks/toast';

type AddToast = (message: Omit<ToastMessage, 'id'>) => void;

let addToastRef: AddToast | null = null;

export function registerToast(addToast: AddToast): void {
  addToastRef = addToast;
}

export function showToast(message: Omit<ToastMessage, 'id'>): void {
  addToastRef?.(message);
}
